import { combineReducers } from 'redux';

import infoTab from './infoTab';
import patientMedia from './patientMedia';
import currentAppointment from './currentAppointment';
import caseData from './caseData';

export default combineReducers({
  infoTab,
  patientMedia,
  currentAppointment,
  caseData,
});
